/* eslint-disable no-invalid-this */

import {convertSeconds} from '../utils/convert-seconds';

const initTrackHandlers = () => {
  const allTracks = document.querySelectorAll('.track[data-track-id]');
  const allAudios = document.querySelectorAll('audio[data-track-id]');

  if (!allTracks && !allAudios) {
    return;
  }

  function addStartDuration(track) {
    const audio = track.querySelector('audio');
    const duration = (audio.duration).toFixed(0);
    const MSTimeFormat = convertSeconds(Number(duration).toFixed(0));
    const trackDurationElement = track.querySelector('[data-track-duration]');

    trackDurationElement.textContent = MSTimeFormat;
  }

  function durationHandler() {
    const duration = this.duration.toFixed(1);
    const currentTime = this.currentTime;
    const progress = Number(((currentTime / duration) * 100).toFixed(2));

    const timeLeft = convertSeconds((Number(duration - currentTime)).toFixed(0));

    const track = document.querySelector(
        `.track[data-track-id="${this.dataset.trackId}"]`
    );
    const timeline = track.querySelector('[data-track-timeline]');
    const trackDurationElement = track.querySelector('[data-track-duration]');

    trackDurationElement.textContent = `-${timeLeft}`;
    timeline.style.width = `${progress}%`;
  }

  function endHandler() {
    const track = this.closest('.track[data-track-id]');
    track.dataset.trackStatus = 'paused';
    this.pause();
  }

  allAudios.forEach((audio) => {
    const track = audio.closest('.track[data-track-id]');

    audio.addEventListener('timeupdate', durationHandler);
    audio.addEventListener('ended', endHandler);

    audio.addEventListener('loadedmetadata', () => {
      addStartDuration(track);
    });
  });
};

export {initTrackHandlers};
